var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 83,
    viewBox: "0 0 54 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.24609,
    y: 40.7305,
    width: 37.1258,
    height: 34.2329,
    fill: "#EF4D3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.712 4.56938L23.1942 4.56941L23.1942 13.2482L30.6676 13.2482L30.6676 4.56941L41.516 4.56941L41.516 13.2482L49.2305 13.2482L49.2305 26.7485L45.3723 26.7485L45.3723 40.7309L8.24649 40.7309L8.24649 31.6905L4.14819 31.6905L4.14819 13.6097L12.1037 13.6097L12.1037 4.56933L22.712 4.56938Z",
    fill: "#FFB800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.53125,
    y: 29.1592,
    width: 3.85723,
    height: 41.9474,
    fill: "#190D11"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.38672,
    y: 33.0166,
    width: 3.85723,
    height: 38.0901,
    fill: "#FFCDA9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 33.0166,
    width: 3.85723,
    height: 32.7864,
    fill: "#6E2B24"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5156,
    y: 40.7305,
    width: 3.85723,
    height: 34.2329,
    fill: "#97372E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6562,
    y: 65.8027,
    width: 3.85723,
    height: 9.16092,
    fill: "#B14D43"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2305,
    y: 29.1592,
    width: 3.85723,
    height: 41.9474,
    fill: "#190D11"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.38672,
    y: 29.1592,
    width: 3.85723,
    height: 3.85723,
    fill: "#190D11"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6211,
    y: 16.1406,
    width: 3.85723,
    height: 3.85723,
    fill: "#190D11"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8516,
    y: 28.1943,
    width: 3.85723,
    height: 12.536,
    fill: "#190D11"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7812,
    y: 17.1055,
    width: 3.85723,
    height: 17.8397,
    transform: "rotate(-90 20.7812 17.1055)",
    fill: "#190D11"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 29.1592,
    width: 3.85723,
    height: 3.85723,
    fill: "#190D11"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8.24609,
    y: 33.0166,
    width: 3.85723,
    height: 3.85723,
    fill: "#190D11"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8.24609,
    y: 36.873,
    width: 3.85723,
    height: 3.85723,
    fill: "#FFCDA9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5156,
    y: 33.0166,
    width: 3.85723,
    height: 7.71445,
    fill: "#190D11"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.1016,
    y: 36.873,
    width: 3.85723,
    height: 3.85723,
    fill: "#190D11"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8.24609,
    y: 4.56934,
    width: 3.85723,
    height: 7.71445,
    fill: "#190D11"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2305,
    y: 13.248,
    width: 3.85723,
    height: 13.5003,
    fill: "#190D11"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6758,
    y: 0.711914,
    width: 3.85723,
    height: 11.5717,
    transform: "rotate(90 23.6758 0.711914)",
    fill: "#190D11"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8164,
    y: 4.56934,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 19.8164 4.56934)",
    fill: "#FFDC83"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5156,
    y: 4.56934,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 41.5156 4.56934)",
    fill: "#FFDC83"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3359,
    y: 24.3369,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 19.3359 24.3369)",
    fill: "#BF6717"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8516,
    y: 36.873,
    width: 3.85723,
    height: 2.89292,
    transform: "rotate(90 18.8516 36.873)",
    fill: "#BF6717"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 11.6211,
    y: 16.1406,
    width: 3.85723,
    height: 7.2323,
    transform: "rotate(90 11.6211 16.1406)",
    fill: "#FFDC83"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 15.4766,
    y: 19.998,
    width: 8.19661,
    height: 3.85723,
    transform: "rotate(90 15.4766 19.998)",
    fill: "#BF6717"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7656,
    y: 17.1055,
    width: 23.6255,
    height: 3.85723,
    transform: "rotate(90 34.7656 17.1055)",
    fill: "#BF6717"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5156,
    y: 8.42578,
    width: 8.67876,
    height: 3.85723,
    transform: "rotate(90 41.5156 8.42578)",
    fill: "#BF6717"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2305,
    y: 17.1055,
    width: 12.0538,
    height: 3.85723,
    transform: "rotate(90 49.2305 17.1055)",
    fill: "#BF6717"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5156,
    y: 29.1592,
    width: 11.5717,
    height: 6.75015,
    transform: "rotate(90 41.5156 29.1592)",
    fill: "#BF6717"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 13.248,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 45.3711 13.248)",
    fill: "#FFDC83"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 29.1592,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 45.3711 29.1592)",
    fill: "#FFDC83"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6211,
    y: 25.3018,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 38.6211 25.3018)",
    fill: "#FFDC83"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6211,
    y: 17.1055,
    width: 8.19661,
    height: 3.85723,
    transform: "rotate(90 38.6211 17.1055)",
    fill: "#FFDC83"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9102,
    y: 13.248,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 30.9102 13.248)",
    fill: "#FFDC83"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5664,
    y: 28.1943,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(90 26.5664 28.1943)",
    fill: "#FFDC83"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6367,
    y: 17.1055,
    width: 7.2323,
    height: 3.85723,
    transform: "rotate(90 24.6367 17.1055)",
    fill: "#FFDC83"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9102,
    y: 32.0518,
    width: 4.33938,
    height: 3.85723,
    transform: "rotate(-180 30.9102 32.0518)",
    fill: "#FFDC83"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5156,
    y: 0.711914,
    width: 3.85723,
    height: 10.6074,
    transform: "rotate(90 41.5156 0.711914)",
    fill: "#190D11"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 13.248,
    width: 3.85723,
    height: 8.67876,
    transform: "rotate(-180 45.3711 13.248)",
    fill: "#190D11"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 13.248,
    width: 3.85723,
    height: 7.71445,
    transform: "rotate(-90 45.3711 13.248)",
    fill: "#190D11"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9102,
    y: 13.248,
    width: 3.85723,
    height: 8.67876,
    transform: "rotate(-180 30.9102 13.248)",
    fill: "#190D11"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0508,
    y: 13.248,
    width: 3.85723,
    height: 3.85723,
    transform: "rotate(-180 27.0508 13.248)",
    fill: "#190D11"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 4.38672,
    y: 12.2832,
    width: 11.0895,
    height: 3.85723,
    fill: "#190D11"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 0.53125,
    y: 12.2832,
    width: 3.85723,
    height: 14.4646,
    fill: "#190D11"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9609,
    y: 40.7305,
    width: 21.6969,
    height: 3.85723,
    fill: "#190D11"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6562,
    y: 36.873,
    width: 3.85723,
    height: 3.85723,
    fill: "#190D11"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1758,
    y: 74.9639,
    width: 35.1972,
    height: 3.85723,
    fill: "#190D11"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5117,
    y: 78.8213,
    width: 26.5184,
    height: 3.85723,
    fill: "#190D11"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 4.38672,
    y: 71.1064,
    width: 5.78584,
    height: 3.85723,
    fill: "#190D11"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 74.9639,
    width: 9.16092,
    height: 3.85723,
    transform: "rotate(-90 45.3711 74.9639)",
    fill: "#190D11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleAdminIcon);
export default __webpack_public_path__ + "static/media/role_admin_icon.ba5c4bac7c128c241b681d68772d64cf.svg";
export { ForwardRef as ReactComponent };